export enum MobileStepperVariant {
  Dots = 'dots',
  Text = 'text',
  Progress = 'progress',
}
